import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './theme.css';
import './i18n'; // initialise i18next avant le rendu

// Applique le thème sauvegardé immédiatement (évite le flash)
const savedTheme = localStorage.getItem('ebios_theme');
const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
document.documentElement.setAttribute('data-theme', savedTheme || systemTheme);

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
